module.exports = __webpack_public_path__ + "img/pexels-telephone.ea43aa95.webp";